import _ from 'lodash'
export default function doLogin(state = [], action) {
  const newState = _.cloneDeep(state)
  switch (action.type) {
    case 'GET_USERS_FETCHED':
        return Object.assign({}, newState, {users: action.data})
    case 'RESET_ADMIN':
        return Object.assign({}, newState, {users: action.data})
    default:
      return newState
  }
}
